import AuthPageLayout from './AuthPageLayout';

const AuthForm = ({ logoSrc, onLogoClick, topRight, className = '', logoClassName = '', children }: any) => {
    const logoPlacement = `w-[12.5rem] md:absolute md:left-1/2 md:top-8 md:-translate-x-1/2 ${logoClassName}`;

    return (
        <AuthPageLayout className={className}>
            {topRight ? <div className='absolute right-4 top-4'>{topRight}</div> : null}
            {onLogoClick ? (
                // A clickable logo is a navigation control, so it has to be a real
                // button to stay reachable by keyboard. The img alt names it.
                <button
                    type='button'
                    onClick={onLogoClick}
                    className={`cursor-pointer border-0 bg-transparent p-0 ${logoPlacement}`}
                >
                    <img src={logoSrc} alt='Logo' className='w-full' />
                </button>
            ) : (
                <img src={logoSrc} alt='Logo' className={logoPlacement} />
            )}
            {children}
        </AuthPageLayout>
    );
};

export default AuthForm;
